import { Step } from 'semantic-ui-react';
import React, { FunctionComponent } from 'react';

export enum StepValue {
    SELECT_PUBLICATION = 1,
    EDIT_PUBLICATION,
    VERIFY_EDITED_PUBLICATION,
}

export interface StepConfig {
    step: StepValue;
    text: string;
    transitionBackOp?: () => void;
    transitionNextOp?: () => void;
}

export interface ProgressConfig {
    attached?: boolean | 'bottom' | 'top';
    columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
    stepConfig: StepConfig[];
    activeStep: StepValue;
}

export const PublicationEditProgressBar: FunctionComponent<ProgressConfig> = ({
    attached = 'bottom',
    columns = 3,
    activeStep = StepValue.SELECT_PUBLICATION,
    stepConfig,
}) => {
    return (
        <Step.Group attached={attached} ordered widths={columns} data-testid={'PublicationEditProgressBar.group'}>
            {stepConfig.map((stepEntry, idx) => (
                <Step key={idx} active={activeStep === stepEntry.step} data-testid={'PublicationEditProgressBar.step'}>
                    <Step.Content>
                        <Step.Title>{stepEntry.text}</Step.Title>
                    </Step.Content>
                </Step>
            ))}
        </Step.Group>
    );
};

export function getNextStep(activeStep: StepValue, upperBound: number = Object.keys(StepValue).length / 2): StepValue {
    // @ts-ignore
    return StepValue[StepValue[Math.min(upperBound, activeStep + 1)]];
}

export function getPreviousStep(activeStep: StepValue): StepValue {
    // @ts-ignore
    return StepValue[StepValue[Math.max(1, activeStep - 1)]];
}
